import { useState, useEffect } from 'react';
import axios from 'axios';
import { buildApiUrl } from '../apiBase';
import { parseLocalDate } from '../utils/timeUtils';

// Shared by MacdChart + RsiChart on StockDetail's daily tab. Previously each
// fetched /stocks/<symbol>/indicators?limit=250 independently -- identical
// payload, two HTTP round-trips. See "StockDetail fires 11 requests for 5
// payloads" (Tech Debt 2026-09).
export function useDailyIndicators(symbol, { limit = 250, enabled = true } = {}) {
  const [indicators, setIndicators] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!symbol || !enabled) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);
    axios.get(buildApiUrl(`/stocks/${symbol}/indicators?limit=${limit}`))
      .then((response) => {
        if (cancelled) return;
        const rows = response.data?.indicators || [];
        setIndicators(rows.slice().sort((a, b) => parseLocalDate(a.date) - parseLocalDate(b.date)));
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('Error fetching indicators:', err);
        setError(err.message);
        setIndicators([]);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [symbol, limit, enabled]);

  return { indicators, loading, error };
}
